import { createApi } from "@reduxjs/toolkit/query/react";
import { rtkBaseQuery } from "../baseQuery";

export const tenantAdminApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: "tenantAdminApi",
  tagTypes: ["TenantDashboard", "TenantUsers"],
  endpoints: (builder) => ({
    getTenantDashboard: builder.query({
      query: () => ({
        url: "/tenant/dashboard/",
        method: "GET",
      }),
      providesTags: ["TenantDashboard"],
    }),
    getTenantUsers: builder.query({
      query: () => ({
        url: "/tenant/users/",
        method: "GET",
      }),
      providesTags: ["TenantUsers"],
    }),
    inviteTenantUser: builder.mutation({
      query: (body) => ({
        url: "/tenant/invite/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["TenantDashboard", "TenantUsers"],
    }),
    removeTenantUser: builder.mutation({
      query: (userId) => ({
        url: `/tenant/users/${userId}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["TenantDashboard", "TenantUsers"],
    }),
    uploadTenantDocument: builder.mutation({
      query: (formData) => ({
        url: "/tenant/upload-document/",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["TenantDashboard"],
    }),
    deleteTenantDocument: builder.mutation({
      query: (docId) => ({
        url: `/tenant/documents/${docId}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["TenantDashboard"],
    }),
  }),
});

export const {
  useGetTenantDashboardQuery,
  useGetTenantUsersQuery,
  useInviteTenantUserMutation,
  useRemoveTenantUserMutation,
  useUploadTenantDocumentMutation,
  useDeleteTenantDocumentMutation,
} = tenantAdminApi;
